<template>
  <QuesCard
    :maxwidth="maxwidth"
    :ques="ques"
    :isEdit="isEdit"
    @quesDel="$emit('quesDel')"
  >
    <template slot="title">
      {{ ques.serial == null ? '' : ques.serial + '. ' }}檔案上傳題
    </template>
    <v-card-text class="text-start" slot="content">
      <template v-if="!isEdit">
        <div v-for="(name, idx) in ques.cnName.split(/\r?\n/)" :key="idx">{{ ques.serial == null ? '' : ques.serial + '. ' }}{{ name }}</div>
        <!-- 加上題號在非編輯狀態 -->
      </template>
      <!-- 編輯狀態才顯示的文字輸入區 -->
      <v-textarea
        v-if="isEdit"
        outlined
        rows="1"
        label="題目內容"
        auto-grow
        v-on:click="checkDef()"
        v-model="ques.cnName"
        class="peter-text"
      ></v-textarea>
      <template>
      <v-row class="mt-2 ml-0 pr-3">
        <v-file-input
          v-if="isEdit"
          chips
          filled
          class="pt-0"
          v-model="ques.headingFile"
          accept="image/*"
          @change="onImgChangeHeading($event)"
          label="File input"
        >
        </v-file-input>
      </v-row>
      <v-row>
        <v-col class="pa-0 text-center" >
          <!-- <v-img></v-img> 改成 <img> 來顯示圖片原始的最大尺寸 max-width控制不破圖 -->
          <img
            v-if="ques.questHeadingPic"
            :src="
              ques.questHeadingPic.startsWith('data')
                ? ques.questHeadingPic
                : $store.state.server + ques.questHeadingPic
            "
            style="max-width: 100%"
          />
        </v-col>
      </v-row>
      </template>

      <template>
        <v-file-input show-size label="選擇檔案上傳"></v-file-input>
      </template>
    </v-card-text>
  </QuesCard>
</template>

<script>
import QuesCard from './QuesCard'
export default {
  components: {
    QuesCard,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    maxwidth: {
      type: Number,
      default: null,
    },
    ques: {
      type: Object,
      default: () => {
        return {
          title: '檔案上傳題',
          cnName: '檔案上傳題題目內容',
          value: null,
        }
      },
    },
  },
  computed: {
    QType() {
      return this.$store.state.QType
    },
  },
  methods: {
    onImgChangeHeading(file) {
      if (!file) {
        this.ques.questHeadingPic = null
      } else {
        var fileReader = new FileReader()
        fileReader.addEventListener('load', (e) => {
          this.ques.questHeadingPic = e.target.result
        })
        fileReader.readAsDataURL(file)
      }
    },
    checkDef() {
      if (this.QType.FILE.template.cnName === this.ques.cnName) {
        this.ques.cnName = ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.thiscard {
  border-radius: 10px;
  cursor: grab;
}
</style>
